import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import RemoveOrder from "./RemoveOrder";
import DeliverOrderCustomer from "./DeliverOrderCustomer";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import MuiButton from "../../../shares/MuiButton";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import AdminPrintCurrentOrderiInfo from "./AdminPrintCurrentOrderiInfo";
import ChangeOrderState from "./ChangeOrderState";

const headersList = [
  { colName: "unique_id", name: "سند " },
  { colName: "name", name: "تولیدکننده" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "delivery", name: "دریافت از تولیدکننده" },
  { colName: "change_state", name: "تغییر وضعیت سفارش" },

  { colName: "print", name: "چاپ سفارش" },
  { colName: "remove", name: "لغو سفارش" },
];
const dataKey = ["unique_id", "name", "created_at", "total"];

const mobileHeadersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "name", name: "تولیدکننده" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];

const TabOne = (props) => {
  const { userData } = useUserData();

  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [storeFilter, setStoreFilter] = useState(null);

  const [isFilterOn, setIsFilterOn] = useState(false);

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "textField",
      label_fa: "نام تولیدکننده",
      label_en: "storeName",
      state: storeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 1000,
    count: 0,
  });
  const [currentOerdersList, setCurrentOerdersList] = useState({ results: [] });

  const adminGetCustomerCurrentOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/admin_get_onprogress_provider_request`,
    params: {
      unique_id: fixNumbers(codeFilter),
      date: dateFilter,
      provider_name: storeFilter,
    },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCurrentOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
      rowsWeightSum(res.results);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (codeFilter !== null || dateFilter !== null || storeFilter !== null) {
      setCurrentOerdersList({ results: [] });

      setIsFilterOn(true);
      adminGetCustomerCurrentOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);
    adminGetCustomerCurrentOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: "تغییر وضعیت سفارش",
      component: (it) => (
        <ChangeOrderState
          selectedRow={it}
          adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
        />
      ),
    },
    {
      label: "چاپ",
      component: (it) => <AdminPrintCurrentOrderiInfo selectedRow={it} />,
    },
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveOrder
          selectedRow={it}
          adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
        />
      ),
    },
  ];
  const buttonsList = [
    {
      label: "دریافت از تولیدکننده",
      component: (it) => (
        <DeliverOrderCustomer
          RemoveOrder
          selectedRow={it}
          adminGetCustomerCurrentOrderApi={adminGetCustomerCurrentOrderApi}
        />
      ),
    },
  ];

  const [weightSum, setWeightSum] = useState(0);
  const [weightSumRed, setWeightSumRed] = useState(0);
  const [weightSumGreen, setWeightSumGreen] = useState(0);
  const rowsWeightSum = (res) => {
    let sum = 0;
    let sum_red = 0;
    let sum_green = 0;
    for (let index = 0; index < res.length; index++) {
      sum = sum + parseFloat(res[index].total);
      sum_red = sum_red + parseFloat(res[index].total_red);
      sum_green = sum_green + parseFloat(res[index].total_green);
    }
    setWeightSum(sum);
    setWeightSumRed(sum_red);
    setWeightSumGreen(sum_green);
  };

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setCurrentOerdersList({ results: [] });
    adminGetCustomerCurrentOrderApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-current-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}/${cityFilter}`
    // );
    window.open(
      `/print-providers-current-orders/${codeFilter}/${storeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      {/* <PanelTemplate sidebarActiveLink="c-current-orders"> */}

      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>
      <PanelTable
        header="لیست سفارش‌های جاری :"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={currentOerdersList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
      {/* </PanelTemplate> */}
    </>
  );
};

export default TabOne;
